/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getScenarioPlan} from '../api'

 export const useQueryGetScenarioPlan = createReactQueryHook('getScenarioPlan', getScenarioPlan)
